<compact-layout *ngIf="layout === 'compact'"></compact-layout>
<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<signup-layout *ngIf="layout === 'signup'"></signup-layout>


